<template>
  <div class="my-customere">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <!-- 内容列表 -->
      <van-list
        class="article_list"
        :offset="1"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="customer_div" v-for="(item,i) in dataList" :key="i" @click="toNextRouter(item.id)">
          <img class="img_img" :src="item.headImg || require('../../assets/img/user.png')" alt srcset />
          <div class="title_div">
            <div class="title_com">{{item.name}}</div>
            <div class="title_com">{{item.phoneNo}}</div>
          </div>
          <img class="img_img1" :src="require('./img/arrow.png')" width alt srcset />
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import URL from "@/api/api";
import { Toast } from "vant";
export default {
  name: "myCustomer",
  data() {
    return {
      loading: false,
      finished: false,
      finishedText: '',
      refreshing: false,
      dataList:[],
      page:1,
      size:10
    };
  },
  created() {
  },
  methods: {
    onLoad() {
      this.getData();
    },
    onRefresh() {
      let that = this
      that.finished = false;
      that.page = 0
      that.loading = true;
      that.getData();
    },
    getData(){
      let that = this
      let data={
        agentId:localStorage.getItem('userid'),
        page:that.page,
        size:that.size
      }
      that.$fetchGet(URL.myCustomer.url, data).then(res => {
        Toast.clear()
        //   this.list = res.data.data.url
        let list = res.data.data.records; //请求返回当页的列表
        that.refreshing = false;
        that.loading = false;
        that.total = res.data.data.total;
        if (list == null || list.length === 0) {
          // 加载结束
          that.finished = true;
          that.dataList=list
          return;
        }
        // 将新数据与老数据进行合并
        if (that.pageNum > 0) {
          that.dataList = [...that.dataList, ...list]
        } else {
          that.dataList = list
        }
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.size != list.length) {
          that.finished = true;
        }
        //说明可能还有下一页
        if (that.size == list.length) {
          that.pageNum++;
        }
      })
    },
    toNextRouter(id){
      this.$router.push({path:'/customerArchives',query:{ cusId:id }})
    }
  }
};
</script>
<style lang="less" scoped>
.my-customere {
  width: 375px;
  height: 100vh;
  overflow: scroll;
  background: #ffffff;
  .article_list {
    width: 375px;
    height: 100%;
    .customer_div {
      width: 100%;
      height: 82px;
      display: flex;
      flex-flow: row;
      justify-content: center;
      align-items: center;
      background: url("./img/titleBg.png") no-repeat;
      background-size: 100% 100%;
      margin-bottom: 10px;
      .img_img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
      .title_div {
        width: 270px;
        margin-left: 20px;
        .title_com {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 15px;
          color: #666666;
          &:last-child{
            margin-top: 5px;
          }
        }
      }
      .img_img1 {
        width: 5px;
        height: 7px;
      }
    }
  }
}
</style>